<app-dialog-base class="modalcreateuser" [Title]='"Geozone"|translate' [dialogId]="dialogId" (onClose)="close()"
                 (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Geozone'|translate}}</label>
    <input type="text" placeholder="" *ngIf="model.Zone" [(ngModel)]="model.Zone.Name"
           [readOnly]="true"/>
    <button class="btnlink" (click)="selectGeoZone()">{{ 'Select' | translate }}</button>
  </div>

  <div class="inputgroup">
    <label>{{'Time to travel from previous point'|translate}}</label>
    <input type="time" [(ngModel)]="time" step="1" min="00:00:00" />
  </div>
</app-dialog-base>
<template #objectsListDialog></template>
